/**
 * Created by andrey on 16.05.2025
 */

const CleverAppsGoogleAds = function () {
    AdsPlugin.call(this, connector.CLEVERAPPS_GOOGLE_ADS, {
        cantLoadAndPlayInParallel: true,
        cantLoadAfterPlay: true
    });
};

CleverAppsGoogleAds.prototype = Object.create(AdsPlugin.prototype);
CleverAppsGoogleAds.prototype.constructor = CleverAppsGoogleAds;

CleverAppsGoogleAds.isAppropriate = function () {
    return connector.platform.oneOf(connector.CLEVERAPPS) && connector.utils.isIFrame();
};

CleverAppsGoogleAds.prototype.isNoAdsProductAvailable = function () {
    return true;
};

CleverAppsGoogleAds.prototype._connect = function (callback) {
    connector.platform.callNative("GoogleAds.connect", () => {
        callback(connector.STATUS_CONNECTED);
    });
};

CleverAppsGoogleAds.prototype._cacheAd = function (name, callback) {
    const method = name === AdsPlugin.REWARDED ? "GoogleAds.cacheRewarded" : "GoogleAds.cacheInterstitial";

    connector.platform.callNative(method, (code) => {
        callback(code, true);
    });
};

CleverAppsGoogleAds.prototype._playAd = function (name, ad, callback) {
    connector.platform.callNative("GoogleAds.play", { name }, callback);
};
